export default {
  text: '#343332',
  primary: '#cd9248',
  secondary: '#6a4b24',
  background: 'white',
  backgroundSecondary: '#e3e3db',
  light: '#fdfdfd',
  dark: '#202020'
}
